export default __webpack_public_path__ + "static/media/student-remote.af1a6f0a.png";